import React from "react";
import * as Routes from "./routes/Routes";
import configRouters from "Configs/routes";
import { Switch } from "react-router-dom";
import MobileLayout from "Layouts/MobileLayout";

const RatesMobile = (props) => (
	<Switch>
		<MobileLayout
			exact
			path={configRouters.RatesMobile.route}
			component={Routes.Catalog}
			seoData={props.seoData}
			seoPath={"RatesMobile"}
		/>
	</Switch>
);

export default RatesMobile;
